export default __webpack_public_path__ + "static/media/mixamo.3b26de98.png";